'use strict';
/*
    Autocompleter field base class
*/
namespace Autocompleter {

    export class AutocompleterField {

        prefix: any = '';
        inputField: JQuery;
        areaOverride: string;
        showLoading: boolean = false;
        initialData: any = null;
        debouncedFetch: () => void;

        // Attr
        data: any[] | null;
        currentValue: any[];
        minPrefix: number;
        select: (item: any) => void;
        deselect: () => void;
        setFocus: boolean;
        filterFunction: (prefix: string) => any[];
        titleProp: string;

        // DI - required in derived class
        $scope: any;
        $route: ng.route.IRouteService;
        resourceService: Core.ResourceService;
        autocompleter: any;
        $q: ng.IQService;

        constructor() {
            this.debouncedFetch = _.debounce(() => {
                this.$scope.$evalAsync(this.fetch());
            }, 300);
            this.minPrefix = this.minPrefix || TRPCONFIG.Domain.AutoCompleterMinPrefix;
        }

        init (areaOverride): void {
            if (areaOverride) {
                this.areaOverride = areaOverride;
            }
        }

        change (): void {
            this.debouncedFetch();
        }

        update (result: any): void {
        // Override in derived class to process `fetch()` result
            ;
        }

        addHeader (arr: any[], resourceName: string) {
        // Returns a copy of `arr` with header item prepended
            if (arr.length) {
                return [{
                        Title: this.resourceService.get(resourceName),
                        header: true
                    }].concat(arr);
            }
            return [];
        }

        fetch() {
            this.$scope.$emit('flash:hide');

            if (!this.prefix || !this.prefix.length) {
                this.deselect();
            }

            const area = this.getArea();
            let allowedZeroInput = TRPCONFIG.Domain.AllowZeroInputDestinationAutocompleter
                && TRPCONFIG.Domain.DeviceType === 'Desktop'
                && area !== 'flights'
                && area !== 'transfers';
            if (this.prefix.length < this.minPrefix && !allowedZeroInput) {
                // `initialData` is `null` unless overwritten i.e. for recommendations
                this.data = this.initialData;
                if(area === 'flights-departure') {
                    this.autocompleter.initialDepartureAirports().then(result => this.update(result));
                }
                return this.$q.when(null);

            }

            this.showLoading = true;
            return this.autocompleter.lookup(area, this.prefix, this.filterFunction).then(result => {
                this.showLoading = false;
                if (result.prefix === this.prefix) {
                    this.update(result);
                    return result;
                }
                return null;
            });
        }

        getArea() {
            const current = this.$route.current ? this.$route.current.area : '';
            return this.areaOverride || current;
        }
    }
}
